import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import DataTable from "components/Core/DataTable";
import {
	Row,
	Col,
	ModalHeader,
	ModalBody,
	Form,
	Button,
	ModalFooter,
	Modal,
	Container,
	Label,
	Input,
	FormGroup,
	Collapse,
} from "reactstrap";
import Notify from "../../lib/Utils/Alert";
import { MotionButton } from "../../components/Core/MotionStrap";
import NotificationAlert from "react-notification-alert";
import PurchaseOrder from "../../lib/Core/Backend/Controllers/PurchaseOrder";
import Catalogs from "lib/Core/Backend/Controllers/Catalogs"
import dataTable from "../../assets/scss/react/dataTable.scss"
import Purchaser from "../../lib/Core/Backend/Controllers/Purchaser";
import Spinner from 'react-bootstrap/Spinner';
import Select from "react-select";


const PurchaserInvoice = ({ purchaserId, token }) => {
	const purchaseOrderCtl = useMemo(() => new PurchaseOrder(token), [token]);
	const catalogsCtl = useMemo(() => new Catalogs(token), [token]);
	const table = useRef();
	const alert = useRef();
	const [paymentModal, setPaymentModal] = useState(false);
	const toggle = () => setPaymentModal(!paymentModal);
	// const [pdfurl,setPdfUrl] = useState ([]);
	const [billingInfo, setBillingInfo] = useState(false);
	const [address, setAddress] = useState("");
	const [city, setCity] = useState("");
	const [country, setCountry] = useState([]);
	const [postal, setPostal] = useState("");
	const [countryData, setCountryData] = useState("")
	const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
	const [billingAdd, setBillingAdd] = useState({
		funds: '', // Set default to empty string
		currencyId: null,
		reference:'',
		purchaserId:purchaserId
	})
	const [currencyOption,setCurrencyOption] = useState([]);
	const [currencyValue,setCurrencyValue] =  useState("");
	const [loader,setLoader] = useState(true)
	const [registerLoader,setRegisterLoader] = useState(false)
	const addressData = useRef();
	
	
	const addPayment = () => {
		toggle()

		purchaserCtl.findCurrency(purchaserId, (dat) => {
			if (dat && !dat.error) {
			  const currecyData = dat.map(item => ({
				
				value: item.currencyId,
				label: item.currencyCode
			  }))
			  setCurrencyOption(currecyData)
			} else {
			  setCurrencyOption([]);
			}
		  });

		
	}

	const registerLoaderFile = () =>{
		setTimeout(() => {
			setRegisterLoader(false)
		}, 1500);
	}

	const handleCurrency = (options) =>{
		const currencyoptions = options?.value
		setBillingAdd({
			...billingAdd,
			currencyId: currencyoptions 
		});
		setCurrencyValue(currencyoptions)
		
	  }


	useEffect(()=>{
		if (!!purchaserId){
		purchaserCtl.billingaddress(purchaserId, (billingData) => {
			if (billingData.errorMessage || billingData.error) {
			  // Notify(alert, "danger", billingData.errorMessage ?? billingData.error);
			} else {
				let obj = {
					countryId: billingData?.billingCoutryId,
					street: billingData?.billingAddress,
					city: billingData?.billingCity,
					postalCode: billingData?.billingPostalCode
				  };
		  
				  
				  setBillingAdd(prevState => ({
					...prevState,
					...obj,           
					funds: prevState.funds || '', 
					currencyId: prevState.currencyId || null, 
					reference: prevState.reference || ''
				  }));
				
			}
		  })
		}
	},[purchaserId])

	useEffect(()=>{
  if(!paymentModal){
	setBillingAdd(prevState => ({
		...prevState,
		currencyId: null,
		funds: '',
		reference: ''
	  }));
  }
	},[paymentModal])

	const header = [
		{
			title: "Date",
			data: "date",
			sortable: true,
			searchable: true,
			renderForSelect: (data) => ({ label: data, value: data }),
			type: 'date'
		},
		{ title: "Type", data: "type", sortable: true, searchable: true },
		{ title: "Number", data: "number", sortable: true, searchable: true },
		{
			title: "Reference",
			data: "reference",
			sortable: true,
			searchable: true,
			type: 'Number',
			width: '10%'
		},
		{
          title:"Currency", data: "currency", sortable: true, searchable: true, render:(data)=>{
			if(data){
				return `${data}`
			}
		  }
		},

		{
			title: "Status",
			data: "status",
			sortable: true,
			searchable: true,
			render: (data) => {
				if (data) {
					switch (data) {
						case 1:
						case 2:
						case 5:
						case 6:
						case 7:
						case 8:
						case 9:
						case 10:
						case 11:
						case 12:
						case 13:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-info">pending</span>`;
						case 3:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalRed">canceled</span>`;

						case 4:
							return `<span style="width: 100px" class="badge badge-pill text-white bg-shamrock">completed</span>`;
							case 14:
								return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalRed">Error</span>`;
						case 15:
						return `<span style="width: 149px" class="badge badge-pill text-white bg-radicalRed">Temporary out of stock</span>`;
						default:
							return "Error";
					}
				}
			},
			renderForSelect: (data) => {
				if (data) {
					switch (data) {
						case 1:
							return {
								label: `open`,
								value: 'open',
							};

						case 2:
							return {
								label: `in progress`,
								value: 'in progress',
							};

						case 3:
							return {
								label: `canceled`,
								value: 'canceled',
							};

						case 4:
							return {
								label: `completed`,
								value: 'completed',
							};

						case 5:
							return {
								label: `on hold`,
								value: 'on hold',
							};
						case 6:
							return {
								label: `API low fund`,
								value: 'API low fund',
							};
						case 7:
							return {
								label: `Non API low fund`,
								value: 'Non API low fund',
							};
						case 8:
							return {
								label: `Incomplete`,
								value: 'Incomplete',
							};
						case 9:
							return {
								label: `Invoice Order`,
								value: 'Invoice Order',
							};
						case 10:
							return {
								label: `Non API Invoice Order`,
								value: 'Non API Invoice Order',
							};

						default:
							return {
								label: "error",
								value: 'error',
							};
					}
				}
			},
		},
		{
			title: "Amount",
			data: "amount",
			sortable: true,
			type: 'number',
			render: (data, type, row) => {
				if (!row) {
					return ``
				} else {
					const { type: invoiceType, status } = row;
					if (([1, 2, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(status)) && (invoiceType === "Payment")) {
						return `<span style="width: 100px" class=" text-dark">$${Number(data).toFixed(2).length > 5 ? Number(data).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : Number(data).toFixed(2)}</span>`;
					} else if ([4].includes(status) && (invoiceType === "Payment")) {
						return `<span style="width: 100px" class=" text-success">$${Number(data).toFixed(2).length > 5 ? Number(data).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : Number(data).toFixed(2)}</span>`;

					} else if ([4].includes(status) && (invoiceType === "Order")) {
						return `<span style="width: 100px" class="text-danger">-$${Number(data).toFixed(2).length > 5 ? Number(data).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : Number(data).toFixed(2)}</span>`;
					} else {
						return `<span style="width: 100px" class=" text-dark">$${Number(data).toFixed(2).length > 5 ? Number(data).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : Number(data).toFixed(2)}</span>`;
					}
				}
			}

		},
		{
			title: "Invoice",
			data: "pdfurl",
			sortable: true,
			searchable: false,
			render: (data, type, row) => {


				const { type: invoiceType } = row;
				switch (invoiceType, data) {
					case "Payment":
					case true:
						return `<button class="btn btn-primaryTwo ncentiva-download-api-purchaser" style="font-size:10px; padding:3px 12px; border-radius:28px;display: block;
						margin:0 auto;">Download PDF</button>`;
					case "Order":
					case null:
					case false:
						return ``
				}


			}
		}
	];

	
	useEffect(() => {
		if (!!purchaserId) {

			purchaseOrderCtl.allPurchaser(purchaserId, (data) => {
				if(data.length === 0 ){
					setLoader(false)
				}
				if (data && !data.error) {
					setLoader(false)
					
					const combinedData = data.map((invoice) => ({
						date: invoice.date,
						type: invoice.type,
						number: invoice.number,
						reference: invoice.reference,
						currency: invoice.currency,
						status: invoice.status,
						amount: invoice.amount,
						pdfurl: invoice.invoiceUploaded
					}));

					if (table.current) {
						table.current.dataTable.clear().rows.add(combinedData).draw();
					}
				} else {
					Notify(alert, "danger", data.errorMessage ?? data.error);
				}
			});
		}
	}, [purchaserId]);


	
	const fetchPurchaserData = ()=> {
      
        purchaserCtl.purchaserCheck(purchaserId?`${purchaserId}`:0, (data) => {

			if (data && !data.error) {
				if(data?.users[0]?.enabled == false){
					sessionStorage.removeItem("accessToken")
					  window.location.href="purchaser-auth/login"
			  }
			}else{
			 if((data?.errorMessage=="Purchaser not found"&& data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){
	
				Notify(alert, 'danger', data?.errorMessage ?? data?.error);
					sessionStorage.removeItem("accessToken")
					window.location.href="purchaser-auth/login"
				}
				if((data?.errorMessage.includes("Username was not found") && data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){
		  
				  Notify(alert, 'danger', data?.errorMessage ?? data?.error);
					  sessionStorage.removeItem("accessToken")
					  window.location.href="purchaser-auth/login"
				  }
			}

    })
  }
 
	useEffect(()=>{  
 
	fetchPurchaserData()
	
	},[purchaserId])
	

	useEffect(() => {
		catalogsCtl.countries((data) => {
			if (data && !data.error) {
				setCountry(data);
			} else {
				Notify(alert, "danger", data.error);
			}
		});
	}, [catalogsCtl])

	const downloadPDF = (data, filename) => {
		const blob = new Blob([data],);;
		const url = data;
		const a = document.createElement('a');
		a.href = url;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		window.URL.revokeObjectURL(url);
	};


	const downloadInvoice = (row) => {
		const dowpurchaser = row.data()
		const newNumber = dowpurchaser.number
		purchaseOrderCtl.purchaserPDf(newNumber, (data) => {
			if (data.error || data.errorMessage) {
				Notify(alert, "danger", data.errorMessage ?? data.error);
			} else {
				
				Notify(alert, "success", "File download successfully");
				downloadPDF(data?.downloadLink, `${newNumber}.pdf`)
			}
		})
	}

	const fundPostData = () => {
		setRegisterLoader(true)
		if(billingAdd.funds === "" || billingAdd.funds < 0 || billingAdd.funds == 0){
			Notify(alert, "warning","Funds can not be 0 or negative");
			registerLoaderFile()
			return;
		}
		if(billingAdd.currencyId === null || billingAdd.currencyId === undefined){
			Notify(alert,"warning","Currency is mandatory");
			registerLoaderFile()
			return;
		}
		toggle()
		let obj = billingAdd ;
		if (obj) {
			purchaseOrderCtl.fundDeposite(obj, (data) => {
				if (data && !data.error) {
					const updatedData = {
						date: data.createdAt,
						type: data.type,
						number: data.orderNumber,
						currency: data.currency,
						reference: data.orderReference,
						status: data.status,
						amount: data.amount,
						pdfurl: data.invoice,
						

					};

					if (table.current) {
						table.current.dataTable.row.add(updatedData).draw();
					}
					Notify(alert, "success", "Fund deposite");
					registerLoaderFile()
				} else {
					Notify(alert, "danger", data.errorMessage ?? data.error);
					registerLoaderFile()
				}
			})
		}

	}
	const sanitizeInput = (input) => {
		return input.replace(/[<>\/"'`;()]/g, ""); 
	};


const onAddChange = (e) => {
    let { name, value } = e.target;

    if (name === "reference") {
        value = sanitizeInput(value); 
    }

    setBillingAdd({ ...billingAdd, [name]: value });
};

	return (
		<>
		<Row className="justify-content-between mt-5 mx-4">
				<Col md="3">
					<h1 className="mb-0">Invoices</h1>
				</Col>
				<Col md="9" className={"align-content text-right"}>
					<MotionButton
					className="py-2 btn-primaryTwo"
						initial={{ x: "-500%", opacity: 0 }}
						animate={{
							x: 0,
							opacity: 1,
							transition: { delay: 0.4, duration: 0.5 },
						}}
						
						onClick={addPayment}
					>
						<i className="fas fa-shopping-cart" /> Register Payment
					</MotionButton>

				</Col>
			</Row>
			<NotificationAlert ref={alert} />
			<Container className="mt-5" fluid>
				<Row>
					<Col md="12">
						<div className=" shadow-lg p-4 border bg-white" style={{borderRadius:'7px'}}>
							{loader ? 
								<div className='d-flex justify-content-center align-items-center flex-column vh-50'>
								   <div className="spinner-border text-muted text-center"></div>
								</div>
							:
						<div className="table-responsive P-2 ">
							<DataTable
								ref={table}
								columns={header}
								data={null}
								className=" j_add_order_table j_table_data_design"
								options={{
									saveState: false,
									scrollY: '100px',
									scrollX:true,
									scrollCollapse: true,
									order: [[0, "desc"]],
									dom: 'tip',
									language: {
										paginate: {
											next: "<i class='fas fa-angle-right'></i>",
											previous: "<i class='fas fa-angle-left'></i>",
										},
									},
								}}
								addDownloadBts={[

									{ callback: downloadInvoice, selector: 'button.ncentiva-download-api-purchaser' },
								]}
								enableSelectFilters={true}
							/>
                            
						</div>
                        }
						</div>
					</Col>
				</Row>
			</Container>
			<Modal
				isOpen={paymentModal}
				toggle={toggle}
				backdrop="static"
				centered={true}
				size="lg"
			>
				<ModalHeader toggle={toggle} className="custom_header_colourTwo d-flex align-items-center justify-content-between">
					<h2 className="mb-0" style={{color:"white"}}> Deposit Funds</h2>
				</ModalHeader>
				<Form>
					<ModalBody>
						<Form >
							<Row >
								<Col md="6" style={{ position: "relative" }}>
									<FormGroup>
										<Label for="funds">Topup Amount<span className="required-asterisk">*</span></Label>
										<Input
											onChange={onAddChange}
											name="funds"
											type="number"
											id="funds"
											value={billingAdd?.funds || ''}
											placeholder="Enter Topup Amount"
										/>
									</FormGroup>
								</Col>
								<Col md="6" style={{ position: "relative" }}>
									<FormGroup>
									<label for="Currency">Currency<span className="required-asterisk">*</span></label>
									<Select 
									options={currencyOption}
									isMulti={false}
									onChange={handleCurrency}
									isClearable={true} 
									id="Currency"/>
									</FormGroup>
									</Col>

								<h4
									className="ncentiva-purchase-header-section text-dark"
									onClick={() => setBillingInfo(!billingInfo)}
									style={{ cursor: "pointer" }}
								>
									<i
										className={
											billingInfo
												? "fas fa-chevron-up"
												: "fas fa-chevron-down"
											
										}
									/>
									&nbsp;&nbsp;Billing Address
								</h4>

								<Collapse isOpen={billingInfo} >
									<Row>
										<Col md="12">
											<FormGroup>
												<label
													className="form-control-label"
													htmlFor="input-address"
												>
													Address
												</label>
												<Input
													className="bg-white"
													id="street"
													value={billingAdd?.street}
													name="street"
													onChange={onAddChange}
													placeholder="Home Address"
													type="text"
												/>
											</FormGroup>
										</Col>
									</Row>
									<Row>
										<Col lg="4">
											<FormGroup>
												<label
													className="form-control-label"
													htmlFor="input-city"
												>
													City
												</label>
												<Input
													className="bg-white"
													value={billingAdd?.city}
													name="city"
													onChange={onAddChange}
													id="city"
													placeholder="City"
													type="text"
												/>
											</FormGroup>
										</Col>
										<Col lg="4">
											<FormGroup>
												<Label for="billingCoutryId">Country</Label>
												<Input type="select" name="countryId" value={billingAdd?.countryId} id="countryId" onChange={onAddChange}>
													<option hidden={true}>Select a country</option>
													{country.map((count) => (
														<option key={count.id} value={count.id}>
															{count.name}
														</option>
													))}
												</Input>
											</FormGroup>
										</Col>
										<Col lg="4">
											<FormGroup>
												<label
													className="form-control-label"
													htmlFor="input-country"
												>
													Postal code
												</label>
												<Input
													className="bg-white"
													onChange={onAddChange}
													value={billingAdd?.postalCode}
													name="postalCode"
													id="postalCode"
													placeholder="Postal code"
													type="text"
												/>
											</FormGroup>
										</Col>
									</Row>
								</Collapse>

								<Col md="12" style={{ position: "relative" }}>
									<FormGroup>
										<Label for="reference">Your reference</Label>
										<Input
											type="text"
											id="reference"
											name="reference"
											value={billingAdd?.reference}
											onChange={onAddChange}
											placeholder="Enter Reference"
										/>
									</FormGroup>
								</Col>
							</Row>
						</Form>
					</ModalBody>
					<ModalFooter className="justify-content-start">
						<Row>
							<Col md="12" >
								<button type="button" class="btn btn-primaryTwo" onClick={fundPostData} disabled={registerLoader}>
									Deposit Funds{
										registerLoader && 
										<Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
										margin: "0px 8px"
										}}
									/>
									}
								</button>
							</Col>
						</Row>

					</ModalFooter>
				</Form>
			</Modal>
		</>
	)
}

export default PurchaserInvoice;